import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { EditDeliveryNotesSettingsDialogContentComponent } from './edit-delivery-notes-settings-dialog-content/edit-delivery-notes-settings-dialog-content.component';

@Component({
  selector: 'app-edit-invoice-settings-dialog',
  template: ''
})
export class EditDeliveryNotesSettingsDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private router: Router
  ) { }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(EditDeliveryNotesSettingsDialogContentComponent, { centered: true, backdrop: 'static', size: 's' });

    dialogRef.result.then(toDashboard => {
      if (toDashboard) window.history.go(-2)
      else this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }
}
